import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CirclePlay, RotateCcw } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { storytellerRuntime } from "../storyteller/runtime";
export function StorytellerStory({ story }) {
    const launcherRef = useRef(null);
    const [openState, setOpenState] = useState("idle");
    useEffect(() => {
        const launcher = launcherRef.current;
        return () => {
            if (launcher) {
                storytellerRuntime.releaseStoryLauncher(launcher);
            }
        };
    }, []);
    const openStory = async () => {
        const launcher = launcherRef.current;
        if (!launcher || openState === "opening") {
            return;
        }
        setOpenState("opening");
        try {
            await storytellerRuntime.openStory(story.storyId, launcher);
            setOpenState("idle");
        }
        catch {
            setOpenState("error");
        }
    };
    return (_jsxs("div", { className: "storyteller-story", "data-storyteller-content": "story", "data-open-state": openState, children: [_jsxs("button", { ref: launcherRef, type: "button", className: "storyteller-story__launcher", "aria-label": story.accessibleLabel, "aria-haspopup": "dialog", onClick: () => void openStory(), children: [_jsx("img", { src: story.poster, alt: "", "aria-hidden": "true" }), _jsx("span", { className: "storyteller-story__shade", "aria-hidden": "true" }), _jsx("span", { className: "storyteller-story__play", "aria-hidden": "true", children: openState === "error" ? _jsx(RotateCcw, {}) : _jsx(CirclePlay, {}) }), _jsxs("span", { className: "storyteller-story__copy", children: [_jsxs("small", { children: [story.pageCount, " frames"] }), _jsx("strong", { children: openState === "opening"
                                    ? "Opening story…"
                                    : openState === "error"
                                        ? "Try story again"
                                        : story.actionLabel })] })] }), openState === "error" ? (_jsx("span", { className: "sr-only", role: "status", children: "Story unavailable. Activate the button to try again." })) : null] }));
}
